import { render, staticRenderFns } from "./TabPayment.vue?vue&type=template&id=640e1979&"
import script from "./TabPayment.vue?vue&type=script&lang=js&"
export * from "./TabPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports